import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const team = [{
  name: 'Ashley “Ash” Martis',
  role: 'Founder & CEO',
  points: ['Seven-time founder', 'Venture valuation and diligence expertise', 'Schulich MBA', 'Global venture ecosystem network']
}, {
  name: 'Rishi Sareen',
  role: 'COO',
  points: ['Two-time founder', 'Marketing and private-equity background', 'Cass Business School']
}, {
  name: 'Maaz Rehman',
  role: 'CTO',
  points: ['Amazon cybersecurity experience', 'Bug-bounty and security expertise']
}, {
  name: 'Diljyot Singh',
  role: 'Machine Learning Associate',
  points: ['Master of Artificial Intelligence', 'Vector Institute experience']
}];
export function TeamSlide() {
  return <Slide index={14} data-id="element-286" data-mp="etmcyon4dne2">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-287" data-mp="esb8emluoblw">
        <div className="max-w-[64%]" data-id="element-288" data-mp="1b9n2xpvkurhs">
          <Eyebrow data-id="element-289" data-mp="1baor8w1ltahg">Team</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-290" data-mp="1g8zzj2c93cxk">
            Built by venture operators, enterprise builders and AI security
            experts.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-291" data-mp="11jtuuyun8uia">
          Toronto-based, building for global venture markets.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-4 gap-[2vw]" data-id="element-292" data-mp="siw07763hzcd">
        {team.map((member, i) => <Reveal key={member.name} delay={0.07 * i} className="flex h-full flex-col" data-id="element-293" data-mp="xj1ihwqh69hs" data-mpi={i}>
            <div className="h-px w-full bg-white/15" data-id="element-294" data-mp="ilhil48fr4ih" />
            <h3 className="mt-[2.2vh] text-[clamp(15px,1.7vw,36px)] leading-tight text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-295" data-mp="imsmr55smea4">
              {member.name}
            </h3>
            <p className="mt-[1.1vh] text-[clamp(8px,0.84vw,17px)] uppercase tracking-[0.2em] text-[#3B8CFF]" data-id="element-296" data-mp="2cxfuxf21kgil">
              {member.role}
            </p>
            <ul className="mt-[2vh] space-y-[1.1vh]" data-id="element-297" data-mp="2ghzgsmvsphaa">
              {member.points.map(point => <li key={point} className="text-[clamp(9.5px,1.02vw,21px)] leading-snug text-[#C3CBD9]" data-id="element-298" data-mp="2bhbtab6rzikt">
                  {point}
                </li>)}
            </ul>
          </Reveal>)}
      </div>
    </Slide>;
}